import { useQuery } from '@tanstack/react-query';
import { fetchAnnouncements } from '@/services/announcements';

export const useAnnouncementsQuery = () => {
  return useQuery({
    queryKey: ['announcements'],
    queryFn: fetchAnnouncements,
  });
};
